import React from 'react';
import { useIntl } from 'react-intl';
import { Button } from 'semantic-ui-react';

import { messages } from './schema';

interface TemaAcoesWidgetProps {
  canAdd?: boolean;
  onAddTema?: () => void;
}

/**
 * Botão "Adicionar tema" no fim do fieldset do último tema visível.
 *
 * É um widget (e não conteúdo solto no `Data.tsx`) porque o `InlineForm` só
 * desenha campos dentro do acordeão: fora dele, os botões cairiam abaixo do
 * fieldset "Estilo" que o Volto anexa por último. Não grava valor — o campo
 * existe só para ocupar o lugar no form. Remover é a lixeira no cabeçalho do
 * tema — ver `TemaTitulo`.
 */
const TemaAcoesWidget = ({ canAdd, onAddTema }: TemaAcoesWidgetProps) => {
  const intl = useIntl();
  if (!canAdd) return null;

  return (
    <div className="mpf-onde-atua-temas-actions">
      <Button type="button" primary compact onClick={onAddTema}>
        {intl.formatMessage(messages.addTema)}
      </Button>
    </div>
  );
};

export default TemaAcoesWidget;
